@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.history.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.feature.history.generated.resources/"

internal val Res.string.feature_history_account_balance: StringResource by lazy {
      StringResource("string:feature_history_account_balance", "feature_history_account_balance", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 10, 71),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 10, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 63),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10, 79),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 10, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10, 63),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 10, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 63),
      ))
    }

internal val Res.string.feature_history_account_number: StringResource by lazy {
      StringResource("string:feature_history_account_number", "feature_history_account_number", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 82, 74),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 102, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 74, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 74, 66),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 90, 90),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 74, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 74, 62),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 74, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135, 54),
      ))
    }

internal val Res.string.feature_history_account_number_alter: StringResource by lazy {
      StringResource("string:feature_history_account_number_alter", "feature_history_account_number_alter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74, 60),
      ))
    }

internal val Res.string.feature_history_all: StringResource by lazy {
      StringResource("string:feature_history_all", "feature_history_all", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 157, 39),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 213, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 141, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 141, 35),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 181, 39),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 133, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 137, 35),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 141, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190, 31),
      ))
    }

internal val Res.string.feature_history_amount: StringResource by lazy {
      StringResource("string:feature_history_amount", "feature_history_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222, 42),
      ))
    }

internal val Res.string.feature_history_credits: StringResource by lazy {
      StringResource("string:feature_history_credits", "feature_history_credits", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 197, 43),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 249, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 177, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 177, 43),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 221, 59),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 169, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 173, 43),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 177, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 265, 43),
      ))
    }

internal val Res.string.feature_history_currency: StringResource by lazy {
      StringResource("string:feature_history_currency", "feature_history_currency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309, 44),
      ))
    }

internal val Res.string.feature_history_debited_from: StringResource by lazy {
      StringResource("string:feature_history_debited_from", "feature_history_debited_from", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 241, 64),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 309, 96),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 221, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 221, 52),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 281, 96),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 209, 52),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 217, 52),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 217, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 354, 52),
      ))
    }

internal val Res.string.feature_history_debits: StringResource by lazy {
      StringResource("string:feature_history_debits", "feature_history_debits", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 306, 42),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 406, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 274, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 274, 42),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 378, 50),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 262, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 270, 42),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 274, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 407, 38),
      ))
    }

internal val Res.string.feature_history_description: StringResource by lazy {
      StringResource("string:feature_history_description", "feature_history_description", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 349, 67),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 457, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 317, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 317, 71),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 429, 91),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 301, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 313, 79),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 313, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 446, 67),
      ))
    }

internal val Res.string.feature_history_destination: StringResource by lazy {
      StringResource("string:feature_history_destination", "feature_history_destination", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 514, 51),
      ))
    }

internal val Res.string.feature_history_empty: StringResource by lazy {
      StringResource("string:feature_history_empty", "feature_history_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 538, 73),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 782, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 538, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 526, 85),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 726, 125),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 478, 69),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 530, 89),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 498, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 675, 73),
      ))
    }

internal val Res.string.feature_history_empty_filter: StringResource by lazy {
      StringResource("string:feature_history_empty_filter", "feature_history_empty_filter", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 417, 120),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 557, 224),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 401, 136),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 389, 136),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 521, 204),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 365, 112),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 393, 136),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 377, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 566, 108),
      ))
    }

internal val Res.string.feature_history_error: StringResource by lazy {
      StringResource("string:feature_history_error", "feature_history_error", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 710, 129),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1018, 205),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 714, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 702, 109),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 966, 209),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 642, 97),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 710, 105),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 658, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 839, 93),
      ))
    }

internal val Res.string.feature_history_error_fallback: StringResource by lazy {
      StringResource("string:feature_history_error_fallback", "feature_history_error_fallback", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 612, 46),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 908, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 624, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 612, 46),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 852, 62),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 548, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 620, 46),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 572, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 749, 46),
      ))
    }

internal val Res.string.feature_history_error_oops: StringResource by lazy {
      StringResource("string:feature_history_error_oops", "feature_history_error_oops", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 659, 50),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 971, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 671, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 659, 42),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 915, 50),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 599, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 667, 42),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 619, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 796, 42),
      ))
    }

internal val Res.string.feature_history_filter_apply: StringResource by lazy {
      StringResource("string:feature_history_filter_apply", "feature_history_filter_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 840, 72),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1224, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 828, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 812, 64),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1176, 100),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 740, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 816, 56),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 760, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 933, 56),
      ))
    }

internal val Res.string.feature_history_filter_by_account: StringResource by lazy {
      StringResource("string:feature_history_filter_by_account", "feature_history_filter_by_account", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 913, 85),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1337, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 885, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 877, 69),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1277, 141),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 797, 77),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 873, 69),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 817, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 990, 69),
      ))
    }

internal val Res.string.feature_history_filter_clear_all: StringResource by lazy {
      StringResource("string:feature_history_filter_clear_all", "feature_history_filter_clear_all", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 999, 60),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1503, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 955, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 947, 56),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1419, 88),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 875, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 943, 56),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 887, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1060, 52),
      ))
    }

internal val Res.string.feature_history_filter_content_desc: StringResource by lazy {
      StringResource("string:feature_history_filter_content_desc", "feature_history_filter_content_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1060, 59),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1576, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1012, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1004, 55),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1508, 71),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 932, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1000, 55),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 940, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1113, 51),
      ))
    }

internal val Res.string.feature_history_filter_title: StringResource by lazy {
      StringResource("string:feature_history_filter_title", "feature_history_filter_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1120, 76),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1648, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1068, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1060, 68),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1580, 108),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 984, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1056, 64),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 996, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1165, 64),
      ))
    }

internal val Res.string.feature_history_filter_transaction_type: StringResource by lazy {
      StringResource("string:feature_history_filter_transaction_type", "feature_history_filter_transaction_type", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1197, 79),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1757, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1133, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1129, 75),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1689, 111),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1045, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1121, 75),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1053, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1230, 71),
      ))
    }

internal val Res.string.feature_history_header_account: StringResource by lazy {
      StringResource("string:feature_history_header_account", "feature_history_header_account", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1277, 62),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1853, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1209, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1205, 58),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1801, 62),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1117, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1197, 54),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1125, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1302, 58),
      ))
    }

internal val Res.string.feature_history_header_all: StringResource by lazy {
      StringResource("string:feature_history_header_all", "feature_history_header_all", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1340, 70),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1940, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1264, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1264, 66),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1864, 74),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1172, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1252, 62),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1184, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1361, 58),
      ))
    }

internal val Res.string.feature_history_header_credit: StringResource by lazy {
      StringResource("string:feature_history_header_credit", "feature_history_header_credit", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1411, 81),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2011, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1331, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1331, 69),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1939, 93),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1227, 61),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1315, 69),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1235, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1420, 65),
      ))
    }

internal val Res.string.feature_history_header_debit: StringResource by lazy {
      StringResource("string:feature_history_header_debit", "feature_history_header_debit", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1493, 72),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2105, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1405, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1401, 68),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2033, 84),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1289, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1385, 68),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1297, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1486, 60),
      ))
    }

internal val Res.string.feature_history_loading: StringResource by lazy {
      StringResource("string:feature_history_loading", "feature_history_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1566, 63),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2190, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1474, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1470, 47),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2118, 75),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1346, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1454, 47),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1358, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1547, 43),
      ))
    }

internal val Res.string.feature_history_no_account: StringResource by lazy {
      StringResource("string:feature_history_no_account", "feature_history_no_account", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1630, 94),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2258, 142),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1518, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1518, 62),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2194, 98),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1386, 74),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1502, 66),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1402, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1591, 58),
      ))
    }

internal val Res.string.feature_history_no_transactions_found: StringResource by lazy {
      StringResource("string:feature_history_no_transactions_found", "feature_history_no_transactions_found", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1725, 109),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2401, 137),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1589, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1581, 81),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2293, 121),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1461, 93),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1569, 85),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1477, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1650, 73),
      ))
    }

internal val Res.string.feature_history_note: StringResource by lazy {
      StringResource("string:feature_history_note", "feature_history_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1724, 36),
      ))
    }

internal val Res.string.feature_history_other: StringResource by lazy {
      StringResource("string:feature_history_other", "feature_history_other", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1835, 41),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2539, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1679, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1663, 37),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2415, 45),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1555, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1655, 37),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1563, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1761, 37),
      ))
    }

internal val Res.string.feature_history_paid_to: StringResource by lazy {
      StringResource("string:feature_history_paid_to", "feature_history_paid_to", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1877, 63),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2601, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1717, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1701, 43),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2461, 87),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1597, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1693, 39),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1605, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1799, 43),
      ))
    }

internal val Res.string.feature_history_pan_id: StringResource by lazy {
      StringResource("string:feature_history_pan_id", "feature_history_pan_id", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1941, 46),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2697, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1761, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1745, 38),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2549, 62),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1653, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1733, 38),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1653, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1843, 38),
      ))
    }

internal val Res.string.feature_history_select_account: StringResource by lazy {
      StringResource("string:feature_history_select_account", "feature_history_select_account", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1988, 66),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2768, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1804, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1784, 70),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2612, 78),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1692, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1772, 62),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1712, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1882, 58),
      ))
    }

internal val Res.string.feature_history_share: StringResource by lazy {
      StringResource("string:feature_history_share", "feature_history_share", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 2055, 45),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2899, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1867, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1855, 41),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2691, 65),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1747, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1835, 45),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1771, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1941, 37),
      ))
    }

internal val Res.string.feature_history_specific_transactions_history: StringResource by lazy {
      StringResource("string:feature_history_specific_transactions_history", "feature_history_specific_transactions_history", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 2101, 97),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2973, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1909, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1897, 109),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2757, 133),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1789, 89),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1881, 105),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1813, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1979, 93),
      ))
    }

internal val Res.string.feature_history_title: StringResource by lazy {
      StringResource("string:feature_history_title", "feature_history_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 2199, 45),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 3123, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2015, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2007, 45),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2891, 53),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1879, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1987, 45),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1903, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2073, 41),
      ))
    }

internal val Res.string.feature_history_transaction_amount: StringResource by lazy {
      StringResource("string:feature_history_transaction_amount", "feature_history_transaction_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2115, 70),
      ))
    }

internal val Res.string.feature_history_transaction_date: StringResource by lazy {
      StringResource("string:feature_history_transaction_date", "feature_history_transaction_date", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 2245, 80),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 3177, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2057, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2053, 72),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2945, 100),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1921, 68),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2033, 72),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1945, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2186, 68),
      ))
    }

internal val Res.string.feature_history_transaction_details: StringResource by lazy {
      StringResource("string:feature_history_transaction_details", "feature_history_transaction_details", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 2326, 83),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 3278, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2130, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2126, 79),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3046, 91),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1990, 67),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2106, 75),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 2014, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2255, 71),
      ))
    }

internal val Res.string.feature_history_transaction_id: StringResource by lazy {
      StringResource("string:feature_history_transaction_id", "feature_history_transaction_id", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 2410, 78),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 3378, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2210, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2206, 66),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3138, 86),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 2058, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2182, 66),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 2082, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2327, 62),
      ))
    }

internal val Res.string.feature_history_transaction_type: StringResource by lazy {
      StringResource("string:feature_history_transaction_type", "feature_history_transaction_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2390, 64),
      ))
    }

internal val Res.string.feature_history_transferred_from: StringResource by lazy {
      StringResource("string:feature_history_transferred_from", "feature_history_transferred_from", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2455, 64),
      ))
    }

internal val Res.string.feature_history_transferred_to: StringResource by lazy {
      StringResource("string:feature_history_transferred_to", "feature_history_transferred_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2520, 58),
      ))
    }

internal val Res.string.feature_history_view_Receipt: StringResource by lazy {
      StringResource("string:feature_history_view_Receipt", "feature_history_view_Receipt", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 2489, 64),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 3465, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2277, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2273, 56),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 2117, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2249, 52),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 2157, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2579, 52),
      ))
    }

internal val Res.string.feature_history_view_receipt: StringResource by lazy {
      StringResource("string:feature_history_view_receipt", "feature_history_view_receipt", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3225, 76),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_history_account_balance", Res.string.feature_history_account_balance)
  map.put("feature_history_account_number", Res.string.feature_history_account_number)
  map.put("feature_history_account_number_alter", Res.string.feature_history_account_number_alter)
  map.put("feature_history_all", Res.string.feature_history_all)
  map.put("feature_history_amount", Res.string.feature_history_amount)
  map.put("feature_history_credits", Res.string.feature_history_credits)
  map.put("feature_history_currency", Res.string.feature_history_currency)
  map.put("feature_history_debited_from", Res.string.feature_history_debited_from)
  map.put("feature_history_debits", Res.string.feature_history_debits)
  map.put("feature_history_description", Res.string.feature_history_description)
  map.put("feature_history_destination", Res.string.feature_history_destination)
  map.put("feature_history_empty", Res.string.feature_history_empty)
  map.put("feature_history_empty_filter", Res.string.feature_history_empty_filter)
  map.put("feature_history_error", Res.string.feature_history_error)
  map.put("feature_history_error_fallback", Res.string.feature_history_error_fallback)
  map.put("feature_history_error_oops", Res.string.feature_history_error_oops)
  map.put("feature_history_filter_apply", Res.string.feature_history_filter_apply)
  map.put("feature_history_filter_by_account", Res.string.feature_history_filter_by_account)
  map.put("feature_history_filter_clear_all", Res.string.feature_history_filter_clear_all)
  map.put("feature_history_filter_content_desc", Res.string.feature_history_filter_content_desc)
  map.put("feature_history_filter_title", Res.string.feature_history_filter_title)
  map.put("feature_history_filter_transaction_type", Res.string.feature_history_filter_transaction_type)
  map.put("feature_history_header_account", Res.string.feature_history_header_account)
  map.put("feature_history_header_all", Res.string.feature_history_header_all)
  map.put("feature_history_header_credit", Res.string.feature_history_header_credit)
  map.put("feature_history_header_debit", Res.string.feature_history_header_debit)
  map.put("feature_history_loading", Res.string.feature_history_loading)
  map.put("feature_history_no_account", Res.string.feature_history_no_account)
  map.put("feature_history_no_transactions_found", Res.string.feature_history_no_transactions_found)
  map.put("feature_history_note", Res.string.feature_history_note)
  map.put("feature_history_other", Res.string.feature_history_other)
  map.put("feature_history_paid_to", Res.string.feature_history_paid_to)
  map.put("feature_history_pan_id", Res.string.feature_history_pan_id)
  map.put("feature_history_select_account", Res.string.feature_history_select_account)
  map.put("feature_history_share", Res.string.feature_history_share)
  map.put("feature_history_specific_transactions_history", Res.string.feature_history_specific_transactions_history)
  map.put("feature_history_title", Res.string.feature_history_title)
  map.put("feature_history_transaction_amount", Res.string.feature_history_transaction_amount)
  map.put("feature_history_transaction_date", Res.string.feature_history_transaction_date)
  map.put("feature_history_transaction_details", Res.string.feature_history_transaction_details)
  map.put("feature_history_transaction_id", Res.string.feature_history_transaction_id)
  map.put("feature_history_transaction_type", Res.string.feature_history_transaction_type)
  map.put("feature_history_transferred_from", Res.string.feature_history_transferred_from)
  map.put("feature_history_transferred_to", Res.string.feature_history_transferred_to)
  map.put("feature_history_view_Receipt", Res.string.feature_history_view_Receipt)
  map.put("feature_history_view_receipt", Res.string.feature_history_view_receipt)
}
